import { useContext } from 'react';
import { FormControl, FormControlLabel, SxProps, styled } from '@mui/material';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { AppContext } from '../templates/AppContextProvider';

const AntSwitch = styled((props: SwitchProps) => (
  <Switch
    disableRipple
    {...props}
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const input = e.target as HTMLInputElement;
        input.click();
        input.focus();
      }
    }}
  />
))(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase.Mui-focusVisible': {
    boxShadow: '0 0 0 2px var(--c-primary-color)',
    outline: 'none',
  },
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    margin: 2,
    padding: 2,
    color: 'rgba(0, 0, 0, 0.3)',
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: 'var(--c-secondary-color)',
      '& + .MuiSwitch-track': {
        border: '2px solid var(--c-secondary-color)',
        opacity: 1,
        backgroundColor: 'white',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    border: '2px solid rgba(0, 0, 0, 0.25)',
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: 'white',
    boxSizing: 'border-box',
  },
}));

type Props = {
  placement?: 'start' | 'end';
  sx?: SxProps;
};

export const DarkModeButton = (props: Props) => {
  const ctx = useContext(AppContext);

  const onSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    ctx.setDarkMode(event.target.checked);
  };

  return (
    <FormControl component="fieldset" sx={props.sx}>
      <FormControlLabel
        control={<AntSwitch onChange={(e) => onSwitch(e)} />}
        label={<span className="select-none text-clamp_s ml-1 whitespace-nowrap">Dark Mode</span>}
        labelPlacement={props.placement ?? 'end'}
        sx={{ margin: 0 }}
        checked={ctx.darkMode}
      />
    </FormControl>
  );
};
